<template>
  <div
    class="col-span-6 col-start-1 mt-12 flex h-full max-h-[282px] flex-col laptop:col-span-10 laptop:col-start-2 laptop:mt-14 laptop:h-[482px] laptop:max-h-full"
    :class="props.color"
  >
    <img class="m-auto h-full max-h-full object-contain" :src="props.image" />
    <div
      v-if="props.hasButton"
      class="flex flex-col justify-end pb-4 laptop:flex-row laptop:pr-[46px] laptop:pb-[35px]"
    >
      <NuxtLink
        :to="localePath({ name: 'home' })"
        class="ng800 inline-flex max-w-[263px] items-center justify-end justify-center self-center rounded-md border border-ng70 bg-ng20 px-5 py-[13px] font-medium uppercase leading-[1.2] tracking-[0.08em] shadow-btn hover:bg-ng100 focus:bg-ng100 active:bg-ng100 disabled:opacity-60"
      >
        {{ $t("upload-your-label") }}
        <img class="pb-[1px] pl-[18px]" src="../assets/img/upload-icon.png" />
      </NuxtLink>
    </div>
  </div>
</template>
<script setup lang="ts">
const { t: $t } = useI18n();

const localePath = useLocalePath();
const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
  hasButton: {
    type: Boolean,
    default: false,
    required: false,
  },
});
</script>
<style lang="scss" scoped></style>
